import './PackageDetailsPage.css'

import { Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

import { usePackageFeesFromRequests } from '../../../api/package-req/hooks/usePackageFeesFromRequests'
import calcWeight from '../../../helpers/CalculationFunction'
import { getBrandLogo } from '../../../helpers/getBrandLogo'
import { getPrice } from '../../../helpers/getPrice'
import vIcon from '../../../imgs/check-mark.png'
import grFlag from '../../../imgs/flags/greece.png'
import turkeyFlag from '../../../imgs/flags/turkey.png'
import ukFlag from '../../../imgs/flags/uk.png'
import usaFlag from '../../../imgs/flags/usa.png'
import returnIcon from '../../../imgs/next.png'

export default function PackageDetailsPage() {
  const { EURToUSD, GBPToUSD, packageForPackageDetails } = useSelector(state => state.packages)
  const history = useHistory()

  // Get fees from package requests instead of package entity
  const { data: packageFees } = usePackageFeesFromRequests(packageForPackageDetails)

  useEffect(() => {
    if (packageForPackageDetails == null) {
      history.push(`/personal-info`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getCountryFlagPackage = country => {
    switch (country) {
      case 'TR':
      case '':
      case 'a':
      case 'b':
        return turkeyFlag
      case 'GR':
        return grFlag
      case 'USA':
        return usaFlag
      case 'UK':
        return ukFlag
    }
  }

  const getValue = () => {
    if (packageForPackageDetails.valueInUSD) return packageForPackageDetails.valueInUSD
    else if (packageForPackageDetails.price > 0) return getPrice(packageForPackageDetails, EURToUSD, GBPToUSD)
    return 0
  }

  return (
    <>
      {packageForPackageDetails && (
        <div className='packageDetailsPage-cont'>
          <div className='packageCmp-return-cont' onClick={() => history.goBack()}>
            <div className='packageCmp-return-inner'>
              <img src={returnIcon} className='packageCmp-return-img' />
              <div>חזרה</div>
            </div>
          </div>

          <h2 className='packageCmp-title'>פרטי חבילה</h2>

          <div className='packageCmp-package'>
            <div className='packageCmp-package-brand-cont'>
              <img src={getBrandLogo(packageForPackageDetails.brand)} alt={packageForPackageDetails.brand} width='100px' />
              <span>{packageForPackageDetails.brand}</span>
            </div>
            {packageForPackageDetails.isPaid && (
              <div className='packageCmp-package-row'>
                <span className='bold-span'>מספר מעקב: </span>{' '}
                <span>
                  <Link
                    to={{
                      pathname: `https://public.exelot.com/tracking/${packageForPackageDetails.trackingNumberToIsrael}?lang=he`,
                    }}
                    target='_blank'
                  >
                    {packageForPackageDetails.trackingNumberToIsrael}
                  </Link>
                </span>
              </div>
            )}
            <div className='packageCmp-package-row'>
              <span className='bold-span'>מחסן: </span>{' '}
              <span>
                {packageForPackageDetails.warehouse}{' '}
                <img src={getCountryFlagPackage(packageForPackageDetails.warehouse)} alt='country' className='packageCmp-package-flag' />
              </span>
            </div>
            {packageForPackageDetails.taxFreeFeeUSD > 0 && (
              <div className='packageCmp-package-row'>
                <span className='bold-span'>חבילה מדלוואר? </span>{' '}
                <span>
                  <img src={vIcon} height='18px' />
                </span>
              </div>
            )}
            <div className='packageCmp-package-row'>
              <span className='bold-span'>הגיעה למחסן בתאריך: </span>{' '}
              <span>{packageForPackageDetails.dateArrived.split('-').reverse().join('.')}</span>
            </div>
            {getValue() > 0 && (
              <div className='packageCmp-package-row'>
                <span className='bold-span'>שווי: </span> <span>{`${getValue()}$`}</span>
              </div>
            )}
            <div className='packageCmp-package-row'>
              <span className='bold-span'>פריטים: </span>
              <span style={{ direction: 'ltr' }}>
                {packageForPackageDetails?.contents?.map((c, i) => {
                  return (
                    <Fragment key={i}>
                      <span>
                        {c.quantity} X {c.productCategory}
                      </span>
                      <br />
                    </Fragment>
                  )
                })}
              </span>
            </div>

            <div className='packageCmp-package-row'>
              <span className='bold-span'>גודל ומשקל: </span>{' '}
              <span>
                {packageForPackageDetails.length}x{packageForPackageDetails.height}x{packageForPackageDetails.width} ,{' '}
                {packageForPackageDetails.weight}KG
              </span>
            </div>
            <div className='packageCmp-package-row'>
              <span className='bold-span'>משקל נפחי: </span>{' '}
              <span>
                {calcWeight(
                  packageForPackageDetails.width,
                  packageForPackageDetails.length,
                  packageForPackageDetails.height,
                  packageForPackageDetails.weight
                )}
                KG
              </span>
            </div>
            <div className='packageCmp-package-row'>
              <span className='bold-span'>מספר מעקב מקומי: </span> <span>{packageForPackageDetails.trackingNumberInTurkey}</span>
            </div>
            {packageForPackageDetails.isPaid && (
              <div className='packageCmp-package-row'>
                <span className='bold-span'>שולם בתאריך: </span> <span>{packageForPackageDetails.datePayed}</span>
              </div>
            )}
            <div className='packageCmp-package-row'>
              <span className='bold-span'>סוג משלוח: </span>{' '}
              <span>
                {' '}
                {
                  {
                    pickUpPoint: 'נקודת חלוקה',
                    doorToDoor: 'עד הבית',
                  }[packageForPackageDetails.shippingMethod]
                }
              </span>
            </div>
            {packageForPackageDetails.buyingReciptKey && (
              <div className='packageCmp-package-row'>
                <span className='bold-span'>חשבונית שהועלתה: </span>{' '}
                <span>
                  <a href={packageForPackageDetails.buyingReciptKey} target='_blank' rel='noopener noreferrer'>
                    {' '}
                    לחץ כאן{' '}
                  </a>
                </span>
              </div>
            )}
            {/* <div className="packageCmp-package-row">
              <span className="bold-span">חבילה מאוחדת? </span>{' '}
              <span>{packageForPackageDetails.isUnited > 0 ? `כן, אוחדו ${packageForPackageDetails.isUnited} חבילות` : 'לא'}</span>
            </div> */}
            {/* <div className="packageCmp-package-row">
              <span className="bold-span">ביטוח? </span> <span>{packageForPackageDetails.insurance > 0 ? <img src={vIcon} height="18px" /> : 'לא'}</span>
            </div> */}
            {packageForPackageDetails.couponUsed && (
              <div className='packageCmp-package-row'>
                <span className='bold-span'>קופון </span> <span>{packageForPackageDetails.couponUsed}</span>
              </div>
            )}
            {packageForPackageDetails.photo && (
              <div className='packageCmp-package-row'>
                <span className='bold-span'>תמונה </span>
                <span>
                  <a href={packageForPackageDetails.photo} target='_blank' rel='noopener noreferrer'>
                    לחץ כאן
                  </a>
                </span>
              </div>
            )}
            {packageForPackageDetails.isPaid && (
              <>
                <br />
                <br />
                <h3>תשלומים</h3>
                <div className='packageCmp-package-row'>
                  <span className='bold-span'>משלוח: </span>
                  <span>{packageForPackageDetails.shippingPaid}₪</span>
                </div>

                <div className='packageCmp-package-row-title'>
                  <span>כלול במשלוח: </span>{' '}
                </div>
                <div className='packageCmp-package-row-short'>
                  <span>ביטוח: </span>{' '}
                  <span>{packageForPackageDetails.insurance > 0 ? <span>{packageForPackageDetails.insurance}₪</span> : '0'}</span>
                </div>
                <div className='packageCmp-package-row-short'>
                  <span>תוספת בגין איחוד חבילות: </span>{' '}
                  <span>{packageFees?.uniteFee > 0 ? <span>{packageFees.uniteFee}$</span> : '0'}</span>{' '}
                </div>
                <div className='packageCmp-package-row-short'>
                  <span>דמי אחסון: </span>{' '}
                  <span>
                    {packageForPackageDetails.delayChargePrice ? <span>{packageForPackageDetails.delayChargePrice}$</span> : '0'}
                  </span>{' '}
                </div>
                <div className='packageCmp-package-row-short'>
                  <span>עלות העברה מדלוואר: </span>{' '}
                  <span>{packageForPackageDetails.taxFreeFeeUSD ? <span>{packageForPackageDetails.taxFreeFeeUSD}$</span> : '0'}</span>{' '}
                </div>
                <div className='packageCmp-package-row-short'>
                  <span>עמלת צמצום חבילה: </span>{' '}
                  <span>{packageFees?.shrinkRequestFeeUSD > 0 ? <span>{packageFees.shrinkRequestFeeUSD}$</span> : '0'}</span>{' '}
                </div>
                <div className='packageCmp-package-row-short'>
                  <span>עמלת צילום חבילה: </span>{' '}
                  <span>{packageFees?.photoRequestFeeUSD > 0 ? <span>{packageFees.photoRequestFeeUSD}$</span> : '0'}</span>{' '}
                </div>

                <div className='packageCmp-package-row'>
                  <span className='bold-span'>מיסים: </span>{' '}
                  <span>{packageForPackageDetails.taxes ? <span>{packageForPackageDetails.taxes}₪</span> : '0'}</span>{' '}
                </div>

                <div className='packageCmp-package-row'>
                  <span className='bold-span'>סה"כ: </span>{' '}
                  {packageForPackageDetails.shippingPaid ? (
                    <>
                      {packageForPackageDetails.taxes ? (
                        <span>{(packageForPackageDetails.taxes + packageForPackageDetails.shippingPaid).toFixed(2)}₪</span>
                      ) : (
                        <span>{packageForPackageDetails.shippingPaid}₪</span>
                      )}
                    </>
                  ) : (
                    <span>לא שולם</span>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}
